
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { clearAllUserData } from '@/config/api';
import { Loader2 } from 'lucide-react';

const Reset = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    console.log('🔄 Reset page: Clearing all data and logging out');
    
    // Clear all localStorage data
    clearAllUserData();
    
    // Also call logout to clear any auth state
    logout();
    
    // Small delay to ensure cleanup is complete, then redirect
    const timer = setTimeout(() => {
      console.log('🔄 Reset page: Redirecting to login');
      navigate('/', { replace: true });
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigate, logout]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin mx-auto" />
        <h1 className="text-2xl font-bold">Reseteando aplicación...</h1>
        <p className="text-muted-foreground">
          Limpiando datos locales y redirigiendo al login
        </p>
      </div>
    </div>
  );
};

export default Reset;
